<div class="discussion-nudge-wrapper" *ngIf="nudges?.length">
  <div
    class="discussion-nudge"
    [class.is-closing]="closingNudgeIds.has(nudge.id)"
    [class.task-nudge]="isTaskNudge(nudge)"
    [class.reminder-nudge]="isReminderNudge(nudge)"
    [class.checklist-nudge]="isChecklistNudge(nudge)"
    [class.timesheet-nudge]="isTimesheetNudge(nudge)"
    [class.approval-nudge]="isApprovalNudge(nudge)"
    [class.overdue-nudge]="isOverdueNudge(nudge)"
    [class.project-nudge]="isProjectNudge(nudge)"
    [class.attendance-nudge]="isAttendanceNudge(nudge)"
    [class.workflow-nudge]="isWorkflowNudge(nudge)"
    [class.subtask-nudge]="isSubtaskNudge(nudge)"
    [class.priority-nudge]="isPriorityNudge(nudge)"
    [class.dailyreport-nudge]="isDailyReportNudge(nudge)"
    *ngFor="let nudge of nudges">
    <div class="discussion-glow" *ngIf="!isTaskNudge(nudge) && !isReminderNudge(nudge) && !isChecklistNudge(nudge) && !isTimesheetNudge(nudge) && !isApprovalNudge(nudge) && !isOverdueNudge(nudge) && !isProjectNudge(nudge) && !isAttendanceNudge(nudge) && !isWorkflowNudge(nudge) && !isSubtaskNudge(nudge) && !isPriorityNudge(nudge) && !isDailyReportNudge(nudge)"></div>
    <div class="workflow-glow" *ngIf="isWorkflowNudge(nudge)"></div>
    <div class="subtask-glow" *ngIf="isSubtaskNudge(nudge)"></div>
    <div class="checklist-glow" *ngIf="isChecklistNudge(nudge)"></div>
    <div class="timesheet-glow" *ngIf="isTimesheetNudge(nudge)"></div>
    <div class="approval-glow" *ngIf="isApprovalNudge(nudge)"></div>
    <div class="overdue-glow" *ngIf="isOverdueNudge(nudge)"></div>
    <div class="project-glow" *ngIf="isProjectNudge(nudge)"></div>
    <div class="priority-glow" *ngIf="isPriorityNudge(nudge)"></div>
    <div class="dailyreport-glow" *ngIf="isDailyReportNudge(nudge)"></div>
    <div class="task-left-bar" *ngIf="isTaskNudge(nudge) || isReminderNudge(nudge) || isChecklistNudge(nudge) || isTimesheetNudge(nudge) || isApprovalNudge(nudge) || isOverdueNudge(nudge) || isProjectNudge(nudge) || isAttendanceNudge(nudge) || isWorkflowNudge(nudge) || isSubtaskNudge(nudge) || isPriorityNudge(nudge) || isDailyReportNudge(nudge)"></div>

    <button
      type="button"
      class="close-btn"
      aria-label="Close"
      *ngIf="nudge.dismissible"
      (click)="onCloseClick($event, nudge)">
      &times;
    </button>

    <div class="discussion-icon" *ngIf="nudge.icon && !isTaskNudge(nudge) && !isReminderNudge(nudge) && !isChecklistNudge(nudge) && !isTimesheetNudge(nudge) && !isApprovalNudge(nudge) && !isOverdueNudge(nudge) && !isProjectNudge(nudge) && !isAttendanceNudge(nudge) && !isWorkflowNudge(nudge) && !isSubtaskNudge(nudge) && !isPriorityNudge(nudge) && !isDailyReportNudge(nudge)">
      <img [src]="nudge.icon" alt="chat-icon" draggable="false" />
    </div>

    <div class="task-icon-box" *ngIf="isTaskNudge(nudge)">
      <div class="task-icon">+</div>
    </div>

    <div class="reminder-icon-box" *ngIf="isReminderNudge(nudge)">
      <div class="reminder-icon">🔔</div>
    </div>

    <div class="checklist-icon-box" *ngIf="isChecklistNudge(nudge)">
      <div class="checklist-icon">
        <img src="/assets/images/checkbox--checked.svg" alt="checklist-icon" draggable="false" />
      </div>
    </div>

    <div class="timesheet-icon-box" *ngIf="isTimesheetNudge(nudge)">
      <div class="timesheet-icon">
        <span>&check;</span>
      </div>
    </div>

    <div class="approval-icon-box" *ngIf="isApprovalNudge(nudge)">
      <div class="approval-icon">
        <img src="/assets/images/checkbox--checked.svg" alt="approval-icon" draggable="false" />
      </div>
    </div>

    <div class="overdue-icon-box" *ngIf="isOverdueNudge(nudge)">
      <div class="overdue-icon">
        <span>!</span>
      </div>
    </div>

    <div class="project-icon-box" *ngIf="isProjectNudge(nudge)">
      <div class="project-icon">
        <img src="/assets/images/projectname.svg" alt="project-icon" draggable="false" />
      </div>
    </div>

    <div class="attendance-icon-box" *ngIf="isAttendanceNudge(nudge)">
      <div class="attendance-icon">📍</div>
    </div>

    <div class="workflow-icon-box" *ngIf="isWorkflowNudge(nudge)">
      <div class="workflow-icon">🚀</div>
    </div>

    <div class="subtask-icon-box" *ngIf="isSubtaskNudge(nudge)">
      <div class="subtask-icon">🧩</div>
    </div>

    <div class="priority-icon-box" *ngIf="isPriorityNudge(nudge)">
      <div class="priority-icon">
        <img src="/assets/images/taskpriorityicon.svg" alt="priority-icon" draggable="false" />
      </div>
    </div>

    <div class="dailyreport-icon-box" *ngIf="isDailyReportNudge(nudge)">
      <div class="dailyreport-icon">
        <img src="/assets/images/reportsicon.svg" alt="daily-report-icon" draggable="false" />
      </div>
    </div>

    <div class="discussion-content">
      <span class="discussion-badge" *ngIf="nudge.tag">{{ nudge.tag }}</span>
        <h3>{{ nudge.title }}</h3>
        <p>{{ nudge.message }}</p>
        <button
          type="button"
          class="discussion-btn"
          *ngIf="nudge.ctaText"
          (click)="onCtaClick(nudge)">
          {{ nudge.ctaText }}
        </button>
    </div>
  </div>
</div>
